/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */
import { motorVehicleLookup } from '../../constants/apiRequest/requestConstants/endpoints';
import { makeRequest } from '../../helpers/makeApiRequest';


export const getCarRegLookup = async (carReg, props = {}) => {
  return await makeRequest({
    method: 'GET',
    url: `${motorVehicleLookup}?registrationNumber=${carReg}`,
    history: props.history
  });
};
